// src/components/LeftPanel/ActionBar.js
import React from 'react';
import SidebarToggle from '../elements/SidebarToggle';
import useAppStore from '../../contexts/useAppStore'; 

const ActionBar = () => {
  const isSidebarOpen = useAppStore((state) => state.isSidebarOpen);

  return (
    <div className="h-12 p-4 bg-gray-200 flex justify-start items-center space-x-2">
      {isSidebarOpen && <SidebarToggle />}
      <span>ActionBar</span>
    </div>
  );
};

export default ActionBar;
